import React from 'react';
type HeartMarkProps = {
  className?: string;
};
export function HeartMark({
  className = ''
}: HeartMarkProps) {
  return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-48" data-mp="25hoqb50hvmaw">
      <path d="M12 21s-7.5-4.6-9.6-9.3C.9 8.3 3 4.5 6.7 4.5c2.1 0 3.6 1.1 4.3 2.6h2c.7-1.5 2.2-2.6 4.3-2.6 3.7 0 5.8 3.8 4.3 7.2C19.5 16.4 12 21 12 21z" data-id="element-49" data-mp="1rqjn5sxx4bvt" />
    </svg>;
}